import React, { PropTypes } from 'react';
import AddButton from './../AddButton';
import List from '../../../node_modules/material-ui/List';
import LoadMore from './../LoadMore';
import FetchDataComponent from '../../components/common/FetchDataComponent';

class ManagersList extends FetchDataComponent {
  static propTypes = {
    ...FetchDataComponent.propTypes,
    headerTitle: PropTypes.string,
    listItem: PropTypes.func,
    add: PropTypes.func,
    edit: PropTypes.func.isRequired
  };

  render() {
    let { add, list, items, listItem, hasMore } = this.props;
    let records = list.map(id => items[id]);

    return (
      <div>
        {records.length > 0
          ? (
        <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
          <List>
            {records.map((item, index) => {
              let element = React.createElement(listItem, {
                onClick: () => this.props.edit(item),
                ...item
              });

              return (<span key={item.id || index}>{element}</span>);
            })}
          </List>
        </LoadMore>
        )
          : (<div>Empty list</div>)
        }

        <AddButton onClick={add} />
      </div>
    );
  }
}

export default ManagersList;




// WEBPACK FOOTER //
// ./src/components/List/List.jsx